import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMixpanel, useNotify } from '../../../../../hooks';
import { messages } from '../messages';
import {
  AgentInput,
  useExecutiveSummaryGeneration,
} from '../useExecutiveSummaryGeneration';

export const useRequestExecutiveSummary = ({
  patientId,
}: {
  patientId: string;
}) => {
  const { formatMessage } = useIntl();
  const mixPanel = useMixpanel();
  const [notify] = useNotify();
  const { isGenerating, generateExecutiveSummary } =
    useExecutiveSummaryGeneration({
      patientId,
    });

  const requestExecutiveSummary = useCallback(
    async (agentInput: AgentInput, context: { isRegenerate: boolean }) => {
      // assume scheduled task
      let didSucceed = false;
      if (isGenerating) {
        return;
      }
      try {
        await generateExecutiveSummary(agentInput);
        didSucceed = true;
      } catch (err) {
        console.error(err);
        notify(formatMessage(messages.generateFailure), 'error');
      } finally {
        mixPanel.track(`annual_report_generate_requested`, {
          isRegenerate: context.isRegenerate,
          didSucceed,
          ...agentInput,
        });
      }
    },
    [generateExecutiveSummary, isGenerating, formatMessage, notify, mixPanel],
  );

  return { requestExecutiveSummary };
};
